module.exports = __webpack_public_path__ + "img/address-foreign-mobile.34d488cf.svg";